import { render, staticRenderFns } from "./TDWorkAlerts.vue?vue&type=template&id=1cdff753"
import script from "./TDWorkAlerts.vue?vue&type=script&lang=js"
export * from "./TDWorkAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports